import React from 'react'
import Classnames from 'classnames'
import PropTypes from 'prop-types'
import {
  ImageStyle, //
} from './styled'
import ReactTooltip from 'react-tooltip'
// import { ICONS } from '../../themes'

export class Image extends React.PureComponent {
  render() {
    const {
      className, //
      src,
      alt,
      onMouseEnter,
      onMouseLeave,
      useTootipFor,
      useTootip,
      tootipValue,
      tootipHtmlValue,
      tooltipPlace,
      style,
      offset,
    } = this.props

    return (
      <ImageStyle
        className={Classnames(
          'image-control', //
          className
        )}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        data-tip={tootipValue}
        data-for={useTootipFor}
        style={style}
        data-offset={offset}
      >
        <img src={src} alt={alt} className="image" />
        {useTootip && (
          <ReactTooltip
            id={useTootipFor}
            place={tooltipPlace}
            effect="solid"
            className="background-white"
          >
            {/* {tootipHtmlValue} */}
          </ReactTooltip>
        )}
      </ImageStyle>
    )
  }

  static defaultProps = {
    alt: 'Image',
    tooltipPlace: 'bottom',
  }

  static propTypes = {
    /**
     * [Image] and [Image.Children] - additional classes
     */
    className: PropTypes.string,
  }
}
